import React, { useState } from "react";
import { Link } from "react-router-dom";
import useMobile from "../hooks/useMobile";

/* 사업자 정보 — 전자상거래법 / PG 심사용 (플로우메이커스) */
const BIZ = {
  brand: "플로우메이커스",
  ceo: "강희성",
  bizNo: "182-18-02493",
  bizNoDigits: "1821802493",
  mailOrder: "2026-경기군포-0255",
  addr: "경기 군포시 산본동 79-64 B02호 (우 15805)",
  tel: "0502-6682-6661",
  fax: "031-624-4769",
  email: "sellerlab8@gmail.com",
  privacyOfficer: "강희성",
  host: "(주)위드소프트",
};

const COLS = [
  ["SHOP", [["New", "/shop?tags=NEW"], ["Best", "/shop?sort=popular"], ["Sale", "/shop?tags=SALE"], ["Outerwear", "/shop/outer"], ["Tops", "/shop/top"]]],
  ["EDITORIAL", [["Stories", "/"], ["Lookbook", "/"], ["Brand Spotlight", "/"]]],
  ["HELP", [["Shipping", "/terms"], ["Returns", "/terms"], ["Size Guide", "/shop"], ["Contact", "/terms"]]],
  ["COMPANY", [["이용약관", "/terms"], ["개인정보처리방침", "/privacy"], ["About", "/"], ["B2B", "/"]]],
];

function Row({ label, children }) {
  return (
    <div style={{ display: "flex", gap: 8 }}>
      <span style={{ flexShrink: 0, color: "rgba(244,239,229,0.45)" }}>{label}</span>
      <span style={{ color: "rgba(244,239,229,0.78)" }}>{children}</span>
    </div>
  );
}

export default function Footer() {
  const mobile = useMobile();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const subscribe = (e) => {
    e.preventDefault();
    if (email.trim()) setSent(true);
  };

  return (
    <footer
      style={{
        background: "var(--ink)",
        color: "var(--paper)",
        padding: mobile ? "36px 18px 96px" : "56px 32px 28px",
        marginTop: 48,
      }}
    >
      {/* NEWSLETTER BAND */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: mobile ? "1fr" : "1fr 1fr",
          gap: mobile ? 18 : 40,
          alignItems: "center",
          paddingBottom: mobile ? 28 : 40,
          marginBottom: mobile ? 28 : 40,
          borderBottom: "1px solid rgba(244,239,229,0.14)",
        }}
      >
        <div>
          <div className="eyebrow" style={{ color: "var(--acid)", marginBottom: 10 }}>
            The Weekly Edit
          </div>
          <h2
            className="italic"
            style={{ fontSize: mobile ? 30 : 44, lineHeight: 1.0, color: "var(--paper)" }}
          >
            매주 금요일,<br />새 드롭을 가장 먼저.
          </h2>
        </div>
        <form onSubmit={subscribe} style={{ width: "100%" }}>
          {sent ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                fontSize: 14,
                color: "var(--acid)",
                fontWeight: 600,
              }}
            >
              ✓ 구독 완료 — 첫 드롭 소식을 보내드릴게요.
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                gap: 10,
                borderBottom: "1.5px solid rgba(244,239,229,0.4)",
                paddingBottom: 10,
              }}
            >
              <input
                type="email"
                required
                placeholder="이메일 주소"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={{
                  flex: 1,
                  border: 0,
                  outline: "none",
                  background: "transparent",
                  color: "var(--paper)",
                  fontSize: 15,
                }}
              />
              <button
                type="submit"
                className="btn"
                style={{ background: "var(--acid)", color: "var(--ink)", padding: "8px 18px" }}
              >
                구독 →
              </button>
            </div>
          )}
          <div style={{ fontSize: 11, color: "rgba(244,239,229,0.4)", marginTop: 10 }}>
            구독 시 <Link to="/privacy" style={{ textDecoration: "underline", color: "rgba(244,239,229,0.6)" }}>개인정보처리방침</Link>에 동의하는 것으로 간주됩니다.
          </div>
        </form>
      </div>

      {/* BRAND + LINK COLUMNS */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: mobile ? "1fr 1fr" : "2fr 1fr 1fr 1fr 1fr",
          gap: mobile ? 24 : 28,
          marginBottom: mobile ? 28 : 36,
        }}
      >
        <div style={{ gridColumn: mobile ? "1 / -1" : "auto" }}>
          <div style={{ fontFamily: "var(--f-display)", fontSize: 28, marginBottom: 12 }}>
            fashion
            <em style={{ color: "var(--coral)", fontStyle: "italic" }}>ista.</em>
          </div>
          <div
            style={{
              fontSize: 12,
              color: "rgba(244,239,229,0.7)",
              maxWidth: 340,
              lineHeight: 1.6,
            }}
          >
            에디토리얼 감각의 패션 셀렉트샵. 매주 새로운 드롭과 큐레이션을 소개합니다.
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 18 }}>
            {["Instagram", "YouTube", "Pinterest"].map((s) => (
              <a
                key={s}
                href="/"
                onClick={(e) => e.preventDefault()}
                className="chip"
                style={{
                  background: "transparent",
                  color: "var(--paper)",
                  borderColor: "rgba(244,239,229,0.3)",
                  fontSize: 11,
                }}
              >
                {s}
              </a>
            ))}
          </div>
        </div>
        {COLS.map(([t, items]) => (
          <div key={t}>
            <div className="eyebrow" style={{ color: "rgba(244,239,229,0.7)", marginBottom: 14 }}>
              {t}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 9, fontSize: 12 }}>
              {items.map(([label, to]) => (
                <Link
                  key={label}
                  to={to}
                  style={{ color: "rgba(244,239,229,0.82)", width: "fit-content" }}
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* 사업자 정보 (LEGAL) */}
      <div
        style={{
          borderTop: "1px solid rgba(244,239,229,0.14)",
          paddingTop: 24,
          marginBottom: 22,
        }}
      >
        <div
          className="eyebrow"
          style={{ color: "rgba(244,239,229,0.55)", marginBottom: 14 }}
        >
          사업자 정보
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: mobile ? "1fr" : "repeat(2, minmax(0,1fr))",
            gap: mobile ? 7 : "7px 40px",
            maxWidth: 780,
            fontSize: 11.5,
            lineHeight: 1.5,
            fontFamily: "var(--f-mono)",
            letterSpacing: "0.01em",
          }}
        >
          <Row label="상호">{BIZ.brand}</Row>
          <Row label="대표자">{BIZ.ceo}</Row>
          <Row label="사업자등록번호">
            {BIZ.bizNo}{" "}
            <a
              href={`https://www.ftc.go.kr/bizCommPop.do?wrkr_no=${BIZ.bizNoDigits}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "underline", color: "rgba(244,239,229,0.55)" }}
            >
              [사업자정보확인]
            </a>
          </Row>
          <Row label="통신판매업신고">{BIZ.mailOrder}</Row>
          <Row label="주소">{BIZ.addr}</Row>
          <Row label="호스팅">{BIZ.host}</Row>
          <Row label="고객센터">
            <a href={`tel:${BIZ.tel.replace(/-/g, "")}`} style={{ color: "rgba(244,239,229,0.78)" }}>
              {BIZ.tel}
            </a>
          </Row>
          <Row label="팩스">{BIZ.fax}</Row>
          <Row label="이메일">
            <a href={`mailto:${BIZ.email}`} style={{ color: "rgba(244,239,229,0.78)" }}>
              {BIZ.email}
            </a>
          </Row>
          <Row label="개인정보보호책임자">{BIZ.privacyOfficer}</Row>
        </div>
        <div style={{ fontSize: 10.5, color: "rgba(244,239,229,0.38)", marginTop: 14, maxWidth: 780, lineHeight: 1.6 }}>
          플로우메이커스는 통신판매중개자가 아닌 통신판매업자로서 상품의 주문·배송·환불에 대한 책임을 부담합니다.
          결제 관련 문의는 고객센터로 연락 주시기 바랍니다.
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div
        style={{
          borderTop: "1px solid rgba(244,239,229,0.14)",
          paddingTop: 18,
          display: "flex",
          flexDirection: mobile ? "column" : "row",
          gap: mobile ? 10 : 0,
          justifyContent: "space-between",
          alignItems: mobile ? "flex-start" : "center",
          fontSize: 11,
          color: "rgba(244,239,229,0.5)",
          fontFamily: "var(--f-mono)",
          letterSpacing: "0.05em",
        }}
      >
        <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          <Link to="/terms" style={{ color: "rgba(244,239,229,0.6)" }}>이용약관</Link>
          <Link to="/privacy" style={{ color: "var(--paper)", fontWeight: 700 }}>개인정보처리방침</Link>
          <a
            href={`https://www.ftc.go.kr/bizCommPop.do?wrkr_no=${BIZ.bizNoDigits}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "rgba(244,239,229,0.6)" }}
          >
            사업자정보확인
          </a>
        </div>
        <span>© 2026 {BIZ.brand.toUpperCase()} · FASHIONISTA</span>
      </div>
    </footer>
  );
}
